<button [disabled]="disabled">
    <span *ngIf="!loading">
        <img src="../../assets/images/logo_mitid_white.png" class="mitid-logo" alt="MitID Logo" />
        Log ind med MitID
    </span>
    <app-progress-dots *ngIf="loading"></app-progress-dots>
</button>